import {RouteUrls} from '../../../shared/constants/RouteUrls';
import {Actions, ApiEndpoints} from '../../../shared/constants/ApiEndpoints';
import {PermissionLink} from '../../../shared/permission/PermissionLink';

export const sideMenuItems = {
  '/dashboard': [
    {
      title: 'Dashboard',
      icon: 'dashboard',
      url: '/dashboard',
      permissionLink: null
    }
  ],
  '/accreditation': [
    {
      title: 'Manage Certificates',
      customIcon: 'accr_cert',
      url: `/${RouteUrls.ACCREDITATION.MODULE_BASE}/${RouteUrls.ACCREDITATION.CERTIFICATES}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.ACCR.ACCREDITATION_CERTIFICATE, Actions.BASE_ACTIONS.READ)
    },
    {
      title: 'Pioneer Program',
      icon: 'emoji_events',
      url: `/${RouteUrls.ACCREDITATION.MODULE_BASE}/${RouteUrls.ACCREDITATION.PIONEER_FACILITIES}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.ACCR.PIONEER_PROGRAM, Actions.BASE_ACTIONS.READ)
    }
  ],
  '/financial': [
    {
      title: 'Customers',
      icon: 'people',
      url: `/${RouteUrls.FINANCIAL.FACILITIES_LIST.MODULE_BASE}/${RouteUrls.FINANCIAL.FACILITIES_LIST.LIST}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.ACCOUNT.INVOICE, Actions.BASE_ACTIONS.READ)
    },
    {
      title: 'Invoices',
      customIcon: 'invoice',
      url: `/${RouteUrls.FINANCIAL.INVOICE.MODULE_BASE}/${RouteUrls.FINANCIAL.INVOICE.LIST}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.ACCOUNT.INVOICE, Actions.BASE_ACTIONS.READ)
    },
    {
      title: 'Payments',
      icon: 'payment',
      url: `/${RouteUrls.FINANCIAL.PAYMENT.MODULE_BASE}/${RouteUrls.FINANCIAL.PAYMENT.LIST}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.ACCOUNT.PAYMENT, Actions.BASE_ACTIONS.READ)
    },
    {
      title: 'Estimates',
      customIcon: 'order',
      url: `/${RouteUrls.FINANCIAL.SALE_ORDER.MODULE_BASE}/${RouteUrls.FINANCIAL.SALE_ORDER.LIST}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.ACCOUNT.SALE_ORDER, Actions.BASE_ACTIONS.READ)
    },
    {
      title: 'Rate Codes',
      icon: 'inventory',
      url: `/${RouteUrls.FINANCIAL.PRODUCT.MODULE_BASE}/${RouteUrls.FINANCIAL.PRODUCT.LIST}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.ACCOUNT.PRODUCT, Actions.BASE_ACTIONS.READ)
    },
    {
      title: 'Discounts',
      icon: 'local_offer',
      url: `/${RouteUrls.FINANCIAL.DISCOUNT.MODULE_BASE}/${RouteUrls.FINANCIAL.DISCOUNT.LIST}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.ACCOUNT.DISCOUNT, Actions.BASE_ACTIONS.READ)
    },
    {
      title: 'Classes',
      icon: 'local_offer',
      url: `/${RouteUrls.FINANCIAL.CLASS.MODULE_BASE}/${RouteUrls.FINANCIAL.CLASS.LIST}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.ACCOUNT.CLASS, Actions.BASE_ACTIONS.READ)
    },
    {
      title: 'Forecast Report',
      icon: 'trending_up',
      url: `/${RouteUrls.FINANCIAL.INVOICE.MODULE_BASE}/${RouteUrls.FINANCIAL.INVOICE.INVOICING_LIST}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.ACCOUNT.INVOICE, ApiEndpoints.ACCOUNT.READ_INVOICING)
    },
    {
      title: 'Revenue Recognition',
      icon: 'trending_up',
      url: `/${RouteUrls.FINANCIAL.INVOICE.MODULE_BASE}/${RouteUrls.FINANCIAL.INVOICE.REVENUE_LIST}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.ACCOUNT.INVOICE, ApiEndpoints.ACCOUNT.READ_INVOICING)
    },
    {
      title: 'Late Billing',
      icon: 'watch_later',
      url: `/${RouteUrls.FINANCIAL.INVOICE.MODULE_BASE}/${RouteUrls.FINANCIAL.INVOICE.LATE_BILLING}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.ACCOUNT.INVOICE, ApiEndpoints.ACCOUNT.READ_LATE_BILLING)
    },
    {
      title: 'Terminations',
      icon: 'cancel',
      url: `/${RouteUrls.FINANCIAL.INVOICE.MODULE_BASE}/${RouteUrls.FINANCIAL.INVOICE.TERMINATIONS}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.ACCOUNT.INVOICE, ApiEndpoints.ACCOUNT.READ_TERMINATIONS)
    },
    {
      title: 'Finance Fees',
      icon: 'cancel',
      url: `/${RouteUrls.FINANCIAL.INVOICE.MODULE_BASE}/${RouteUrls.FINANCIAL.INVOICE.FINANCE_FEE}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.ACCOUNT.FINANCE_FEE, Actions.BASE_ACTIONS.READ)
    }
  ],
  '/investigation': [
    {
      title: 'Open Investigations',
      icon: 'account_circle',
      url: `/${RouteUrls.INVESTIGATION.MODULE_BASE}/${RouteUrls.INVESTIGATION.LIST_OPEN}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.INVESTIGATION.INVESTIGATION, Actions.BASE_ACTIONS.READ)
    },
    {
      title: 'Closed Investigations',
      icon: 'account_circle',
      url: `/${RouteUrls.INVESTIGATION.MODULE_BASE}/${RouteUrls.INVESTIGATION.LIST_CLOSED}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.INVESTIGATION.INVESTIGATION, Actions.BASE_ACTIONS.READ)
    }
  ],
  '/account-settings': [
    {
      title: 'Users Management',
      icon: 'account_circle',
      url: `/${RouteUrls.ACCOUNT_SETTINGS.MODULE_BASE}/${RouteUrls.ACCOUNT_SETTINGS.USERS}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.RES.USER, Actions.BASE_ACTIONS.READ)
    },
    {
      title: 'Ask Your Data',
      icon: 'query_stats',
      url: `/${RouteUrls.ACCOUNT_SETTINGS.MODULE_BASE}/${RouteUrls.ACCOUNT_SETTINGS.CHAT}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.RES.USER, Actions.BASE_ACTIONS.READ)
    },
    {
      title: 'Dashboards',
      icon: 'space_dashboard',
      url: `/${RouteUrls.ACCOUNT_SETTINGS.MODULE_BASE}/${RouteUrls.ACCOUNT_SETTINGS.DASHBOARDS}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.RES.USER, Actions.BASE_ACTIONS.READ)
    },
    {
      title: 'Permissions Group',
      icon: 'supervised_user_circle',
      url: `/${RouteUrls.ACCOUNT_SETTINGS.MODULE_BASE}/${RouteUrls.ACCOUNT_SETTINGS.PERMISSION_MANAGER}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.RES.PERMISSION, Actions.BASE_ACTIONS.CREATE)
    },
    {
      title: 'Limit Requests',
      icon: 'verified_user',
      url: `/${RouteUrls.ACCOUNT_SETTINGS.MODULE_BASE}/${RouteUrls.ACCOUNT_SETTINGS.LIMIT_REQUESTS}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.ACCR.APPLICATION, Actions.ACCR_APPLICATION.UPDATE_REQUEST)
    }
  ],
  '/survey': [
    {
      title: 'Surveys Management',
      customIcon: 'management',
      url: `/${RouteUrls.SURVEY.MODULE_BASE}/${RouteUrls.SURVEY.SURVEY_MANAGEMENT}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.SURVEY.SURVEY, Actions.BASE_ACTIONS.READ),
    },
    // {
    //   title: 'Active Surveys',
    //   customIcon: 'd-management',
    //   url: `/${RouteUrls.SURVEY.MODULE_BASE}/${RouteUrls.SURVEY.SURVEY_MANAGEMENT}/active-surveys-list`,
    //   permissionLink: PermissionLink.appendLink(ApiEndpoints.SURVEY.DEFICIENCY, Actions.BASE_ACTIONS.READ),
    //
    // },
    {
      title: 'Surveyors Management',
      customIcon: 'survey',
      url: `/${RouteUrls.SURVEY.MODULE_BASE}/${RouteUrls.SURVEY.SURVEYORS_MANAGEMENT}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.SURVEY.SURVEYORS_MANAGEMENT, Actions.BASE_ACTIONS.READ),
    },
    {
      title: 'Regulators',
      customIcon: 'group',
      url: `/${RouteUrls.SURVEY.MODULE_BASE}/${RouteUrls.SURVEY.REGULATORS}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.SURVEY.ATTRIBUTE, Actions.BASE_ACTIONS.READ)
    },
    {
      title: 'Regulations',
      customIcon: 'group',
      url: `/${RouteUrls.SURVEY.MODULE_BASE}/${RouteUrls.SURVEY.REGULATIONS}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.SURVEY.ATTRIBUTE, Actions.BASE_ACTIONS.READ)
    },
    {
      title: 'Chapters',
      customIcon: 'chapter',
      url: `/${RouteUrls.SURVEY.MODULE_BASE}/${RouteUrls.SURVEY.CHAPTERS}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.SURVEY.ATTRIBUTE, Actions.BASE_ACTIONS.READ)
    },
    {
      title: 'Standards Management',
      customIcon: 'implement',
      url: `/${RouteUrls.SURVEY.MODULE_BASE}/${RouteUrls.SURVEY.LANGUAGE_MANAGEMENT}/${RouteUrls.SURVEY.SURVEY_LANGUAGES}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.SURVEY.STANDARD_MANAGEMENT, Actions.BASE_ACTIONS.READ)
    },
    {
      title: 'Options Management',
      customIcon: 'options',
      url: `/${RouteUrls.SURVEY.MODULE_BASE}/${RouteUrls.SURVEY.SURVEY_OPTIONS}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.SURVEY.OPTION, Actions.BASE_ACTIONS.READ)
    }
    ,
    {
      title: 'Worksheet Management',
      customIcon: 'clipboard',
      url: `/${RouteUrls.SURVEY.MODULE_BASE}/${RouteUrls.SURVEY.WORKSHEETS}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.SURVEY.WORKSHEET, Actions.BASE_ACTIONS.READ)
    }
  ],
  '/application': [
    {
      title: 'New Application',
      icon: 'add_circle',
      url: `/${RouteUrls.APPLICATION.MODULE_BASE}/${RouteUrls.APPLICATION.APPLY}/${RouteUrls.APPLICATION.APPLY_RESET}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.ACCR.APPLICATION, Actions.ACCR_APPLICATION.APPLY)
    }
  ],
  '/facility': [
    {
      title: 'Requests',
      customIcon: 'request',
      url: `/${RouteUrls.FACILITY_INFO.FACILITY}/${RouteUrls.FACILITY_INFO.REQUEST}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.FACILITY_INFO.APPROVAL_REQUEST, Actions.APPROVAL_REQUEST.ADMIN_READ)
    },
    {
      title: 'National Accounts',
      customIcon: 'national_account',
      url: `/${RouteUrls.FACILITY_INFO.FACILITY}/${RouteUrls.FACILITY_INFO.NATIONAL_ACCOUNT}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.FACILITY_INFO.NATIONAL_ACCOUNT, Actions.NATIONAL_ACCOUNT.CREATE)
    }
  ],
  '/facility/update': [
    {
      title: 'Facility Info',
      customIcon: 'chapter',
      url: `/${RouteUrls.FACILITY_INFO.FACILITY}/update/:facilityId`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.RES.FACILITY, Actions.BASE_ACTIONS.READ),
    },
    {
      title: 'Requests',
      customIcon: 'request',
      url: `/${RouteUrls.FACILITY_INFO.FACILITY}/update/${RouteUrls.FACILITY_INFO.REQUEST}/list/:facilityId`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.FACILITY_INFO.APPROVAL_REQUEST, Actions.APPROVAL_REQUEST.FACILITY_READ),
    },
    {
      title: 'Facility Notes',
      icon: 'note',
      url: `/${RouteUrls.FACILITY_INFO.FACILITY}/update/${RouteUrls.FACILITY_INFO.NOTES}/list/:facilityId`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.NOTE.NOTE, Actions.BASE_ACTIONS.READ),
    }
  ],
  '/external-report': [
    {
      title: 'Reports',
      icon: 'view_list',
      url: `/${RouteUrls.EXTERNAL_REPORT.EXTERNAL_REPORT}/${RouteUrls.EXTERNAL_REPORT.WASHINGTON_REPORT}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.SURVEY.SURVEY, Actions.BASE_ACTIONS.READ),
      subItems: [
        {
          title: 'Washington Report',
          icon: 'view_list',
          url: `/${RouteUrls.EXTERNAL_REPORT.EXTERNAL_REPORT}/${RouteUrls.EXTERNAL_REPORT.WASHINGTON_REPORT}`,
          permissionLink: PermissionLink.appendLink(ApiEndpoints.REPORTS.EXTERNAL_REPORTS, Actions.BASE_ACTIONS.READ)
        },
        {
          title: 'South Carolina Report',
          icon: 'view_list',
          url: `/${RouteUrls.EXTERNAL_REPORT.EXTERNAL_REPORT}/${RouteUrls.EXTERNAL_REPORT.SOUTH_CAROLINA_REPORT}`,
          permissionLink: PermissionLink.appendLink(ApiEndpoints.REPORTS.EXTERNAL_REPORTS, Actions.BASE_ACTIONS.READ)
        },
        {
          title: 'New York Report',
          icon: 'view_list',
          url: `/${RouteUrls.EXTERNAL_REPORT.EXTERNAL_REPORT}/${RouteUrls.EXTERNAL_REPORT.NEW_YORK_REPORT}`,
          permissionLink: PermissionLink.appendLink(ApiEndpoints.REPORTS.EXTERNAL_REPORTS, Actions.BASE_ACTIONS.READ)
        }
      ]
    },
    {
      title: 'CMS',
      icon: 'view_list',
      url: `/${RouteUrls.EXTERNAL_REPORT.EXTERNAL_REPORT}/${RouteUrls.EXTERNAL_REPORT.CMS_MONTHLY}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.SURVEY.SURVEY, Actions.BASE_ACTIONS.READ),
      subItems: [
        {
          title: 'Monthly Report',
          icon: 'view_list',
          url: `/${RouteUrls.EXTERNAL_REPORT.EXTERNAL_REPORT}/${RouteUrls.EXTERNAL_REPORT.CMS_MONTHLY}`,
          permissionLink: PermissionLink.appendLink(ApiEndpoints.REPORTS.EXTERNAL_REPORTS, Actions.BASE_ACTIONS.READ)
        },
        {
          title: 'Forecast Report',
          icon: 'view_list',
          url: `/${RouteUrls.EXTERNAL_REPORT.EXTERNAL_REPORT}/${RouteUrls.EXTERNAL_REPORT.CMS_FORECAST}`,
          permissionLink: PermissionLink.appendLink(ApiEndpoints.REPORTS.EXTERNAL_REPORTS, Actions.BASE_ACTIONS.READ)
        },
        {
          title: 'Weekly Report',
          icon: 'view_list',
          url: `/${RouteUrls.EXTERNAL_REPORT.EXTERNAL_REPORT}/${RouteUrls.EXTERNAL_REPORT.CMS_WEEKLY}`,
          permissionLink: PermissionLink.appendLink(ApiEndpoints.REPORTS.EXTERNAL_REPORTS, Actions.BASE_ACTIONS.READ)
        },
        {
          title: 'Custom Report',
          icon: 'view_list',
          url: `/${RouteUrls.EXTERNAL_REPORT.EXTERNAL_REPORT}/${RouteUrls.EXTERNAL_REPORT.CMS_CUSTOM}`,
          permissionLink: PermissionLink.appendLink(ApiEndpoints.REPORTS.EXTERNAL_REPORTS, Actions.BASE_ACTIONS.READ)
        }
      ]
    },
    {
      title: 'Assure Report',
      icon: 'view_list',
      url: `/${RouteUrls.EXTERNAL_REPORT.EXTERNAL_REPORT}/${RouteUrls.EXTERNAL_REPORT.ASSURE}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.SURVEY.SURVEY, Actions.BASE_ACTIONS.READ)
    },
    {
      title: 'Aging Report',
      icon: 'view_list',
      url: `/${RouteUrls.EXTERNAL_REPORT.EXTERNAL_REPORT}/${RouteUrls.EXTERNAL_REPORT.AGING}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.SURVEY.SURVEY, Actions.BASE_ACTIONS.READ)
    },
    {
      title: 'Completed OnSite Surveys',
      icon: 'view_list',
      url: `/${RouteUrls.EXTERNAL_REPORT.EXTERNAL_REPORT}/${RouteUrls.EXTERNAL_REPORT.COMPLETE_SURVEY}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.SURVEY.SURVEY, Actions.BASE_ACTIONS.READ)
    },
    {
      title: 'Deficiencies By Program',
      icon: 'view_list',
      url: `/${RouteUrls.EXTERNAL_REPORT.EXTERNAL_REPORT}/${RouteUrls.EXTERNAL_REPORT.DEFICIENCY_REPORT}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.SURVEY.SURVEY, Actions.BASE_ACTIONS.READ)
    },
    {
      title: 'Deficiencies By Question',
      icon: 'view_list',
      url: `/${RouteUrls.EXTERNAL_REPORT.EXTERNAL_REPORT}/${RouteUrls.EXTERNAL_REPORT.DEFICIENCY_QUESTION_REPORT}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.SURVEY.SURVEY, Actions.BASE_ACTIONS.READ)
    },
    {
      title: 'Reactivated Surveys',
      icon: 'view_list',
      url: `/${RouteUrls.EXTERNAL_REPORT.EXTERNAL_REPORT}/${RouteUrls.EXTERNAL_REPORT.REACTIVATED_SURVEYS}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.SURVEY.SURVEY, Actions.BASE_ACTIONS.READ)
    },
    {
      title: 'Onsite Time In/Out',
      icon: 'view_list',
      url: `/${RouteUrls.EXTERNAL_REPORT.EXTERNAL_REPORT}/${RouteUrls.EXTERNAL_REPORT.ONSITE_TIME_IN_OUT}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.SURVEY.SURVEY, Actions.BASE_ACTIONS.READ)
    },
    {
      title: 'Specialty & Programs',
      icon: 'view_list',
      url: `/${RouteUrls.EXTERNAL_REPORT.EXTERNAL_REPORT}/${RouteUrls.EXTERNAL_REPORT.FACILITY_COUNTS}`,
      permissionLink: PermissionLink.appendLink(ApiEndpoints.SURVEY.SURVEY, Actions.BASE_ACTIONS.READ)
    }
  ]
};
